<template>
	<div>
		<h1>Configurer un traitement</h1>

		<b-form-select
			v-model="project"
			:options="projects_options"
			class="mb-3"
			v-on:input="changeProject" />
		<!-- <b-form-select
			v-if="formats_options"
			v-model="format"
			:options="formats_options"
			class="mb-3" /> -->
		<div v-if="documentation">
			<div
				v-for="doc in documentation"
				v-bind:key="doc"
				style="
					display: inline-block;
					margin-right: 5px;
					margin-bottom: 15px;
				">
				<button
					v-if="doc.url"
					data-toggle="tooltip"
					data-placement="bottom"
					:title="doc.description"
					type="button"
					class="btn btn-dark"
					:style="{ 'background-color': doc.Couleur }">
					<a
						v-html="doc.title"
						:href="doc.url"
						style="color: #ffffff"
						target="_blank"></a>
				</button>
				<b-button
					v-if="doc.markdown"
					v-b-modal="doc.slug"
					:style="{ 'background-color': doc.Couleur }"
					>{{ doc.title }}</b-button
				>
				<b-modal
					:hide-footer="true"
					v-if="doc.markdown"
					:title="doc.title"
					size="xl"
					:id="doc.slug"
					><vue-simple-markdown
						:source="doc.markdown"></vue-simple-markdown
				></b-modal>
			</div>
		</div>
		<p></p>
		<b-tabs content-class="mt-3">
			<b-tab title="Traitement" active>
				<div v-if="launch">
					<p>Téléchargement en cours</p>
					<b-progress :value="counter" animated></b-progress>
				</div>
				<p></p>
				<b-table
					v-if="nb_files > 0"
					striped
					hover
					:items="files"
					:fields="fields">
					<template v-slot:cell(del)="data">
						<b-button
							v-on:click="del_file(data.value, data.value.name)"
							><i class="fas fa-trash-alt"></i
						></b-button>
					</template>
				</b-table>
				<br />
				<edit_tabulator
					@update="update"
					ref="edit_tabulator"></edit_tabulator>
				<div v-if="tabulator_data && !launch">
					<p></p>
					<b-button
						:disabled="!project || (formats_options && !format)"
						variant="success"
						v-on:click="start(['test'], project, 'import', true)"
						>Tester</b-button
					>
					<span v-for="action in list_actions" :key="action.name">
						&nbsp;<b-button
							:disabled="!project || (formats_options && !format)"
							variant="success"
							v-on:click="
								start(
									action.tags,
									action.project,
									action.type,
									true
								)
							"
							>{{ action.name }}</b-button
						>
					</span>
					<span v-if="nb_files > 0" class="marge"
						>Nombre de fichiers : {{ nb_files }} - Taille totale :
						{{ size_files }} mo</span
					>
				</div>
				<div>
					<br />
					<h2 v-show="first">Résultats</h2>
					<treatment
						@file="fileResponse"
						ref="myTreatment"></treatment>
				</div>
			</b-tab>
			<b-tab title="Details" v-if="project_obj">
				<!-- * flex project details -->
				<div
					class="d-flex align-items-center justify-content-between"
					v-if="project_obj && project_obj.description.length > 0">
					<div class="description-title font-weight-bold">
						Description du projet
					</div>
					<div style="white-space: pre-line" class="description-body align-text-bottom w-75">
						{{ project_obj.description }}
					</div>
				</div>
				<hr />
				<!-- * flex scenario details -->
				<div
					class="d-flex justify-content-between align-items-center"
					v-if="scenario && scenario.description.length > 0">
					<div class="description-title font-weight-bold">
						Description du scénario
					</div>
					<div
						style="white-space: pre-line" class="description-body align-text-bottom w-75">
						{{ scenario.description }}
					</div>
				</div>
			</b-tab>
		</b-tabs>
	</div>
</template>

<script>
	import "../../public/js/query-builder.default.min.css";
	import "../../public/js/query-builder.min.js";
	import "../../public/js/query-builder-fr.js";

	const chardet = require("chardet");

	import FadeLoader from "vue-spinner/src/FadeLoader.vue";
	import Tabulator from 'tabulator-tables/dist/js/tabulator.min.js';

	import store from "../store";
	import projects from "../services/projects.js";
	import dataset from "../components/dataset.vue";
	import treatments from "../services/treatments.js";
	import treatment from "../components/treatment.vue";
	import edit_tabulator from "../components/edit_tabulator.vue";
	import scenario from "../services/scenario";

	export default {
		name: "test2",
		components: {
			FadeLoader: FadeLoader,
			treatment: treatment,
			dataset: dataset,
			edit_tabulator,
		},
		data: function () {
			return {
				first: false,
				list_projects: [],
				list_formats: [],
				list_documentation: [],
				list_details: {},
				list_actions: [],
				list_actions_result: [],
				documentation: null,
				projects_options: [
					{ value: null, text: "Sélectionner un projet" },
				],
				project: null,
				formats_options: null,
				format: null,
				launch: false,
				counter: 0,
				fields: [
					{
						key: "name",
						label: "Nom",
					},
					{
						key: "size",
						label: "Taille",
					},
					{
						key: "del",
						label: "",
					},
				],
				files: [],
				nb_files: 0,
				size_files: 0,
				tabulator_data: null,
				tabulator_data_csv: null,
				tabulator_options: {},
				name_file_tabulator: "data.csv",
				name_column: "",
				column_import: [],
				column_import_opt: [],
				line: {},
				selected: "active",
				dowload: false,
				main: true,
				actions_result: false,
				input_menu: "",
				pagination: "local",
				paginationSize: 20,

				project_obj: null,
				scenario: null,
				list_scenarios: [],
			};
		},
		methods: {
			async update(dataset_id, data) {
				//console.log("update")
				//console.log(data)
				this.tabulator_data = data;
			},
			fileResponse: function () {
				this.actions_result = true;
			},
			template: function () {
				return `<div></div>`;
			},
			thumbnail: function (file, dataUrl) {
				var j, len, ref, thumbnailElement;
				if (file.previewElement) {
					file.previewElement.classList.remove("dz-file-preview");
					ref = file.previewElement.querySelectorAll(
						"[data-dz-thumbnail-bg]"
					);
					for (j = 0, len = ref.length; j < len; j++) {
						thumbnailElement = ref[j];
						thumbnailElement.alt = file.name;
						thumbnailElement.style.backgroundImage =
							'url("' + dataUrl + '")';
					}
					return setTimeout(
						(function (_this) {
							return function () {
								return file.previewElement.classList.add(
									"dz-image-preview"
								);
							};
						})(this),
						1
					);
				}
			},
			getScenarios: async function () {
				try {
					this.list_scenarios = await scenario.getby_production();

					// * converti le tableau de scenarios en objet avec clé = scenario.uid
					this.list_scenarios = this.list_scenarios.reduce(
						(obj, item) => {
							obj[item.uid] = item;
							return obj;
						},
						{}
					);
				} catch (error) {
					console.log(error);
				}
			},
			getProjects: async function () {
				try {
					this.list_projects = await projects.getAll();
				} catch (error) {
					console.log(error);
				}
			},
			changeProject: async function () {
				//this.formats_options = this.list_formats[this.project];
				this.documentation = this.list_documentation[this.project];
				try {
					if (this.documentation)
						this.documentation = JSON.parse(this.documentation);
				} catch (err) {}
				this.format = null;
				if (
					this.list_details[this.project] &&
					this.list_details[this.project].column_import
				)
					this.column_import =
						this.list_details[this.project].column_import;
				else this.column_import = {};

				if (
					this.list_details[this.project] &&
					this.list_details[this.project].column_import_opt
				)
					this.column_import_opt =
						this.list_details[this.project].column_import_opt;
				else this.column_import_opt = {};

				if (
					this.list_details[this.project] &&
					this.list_details[this.project].actions
				)
					this.list_actions = this.list_details[this.project].actions;
				else this.list_actions = [];

				if (
					this.list_details[this.project] &&
					this.list_details[this.project].actions_result
				)
					this.list_actions_result =
						this.list_details[this.project].actions_result;
				else this.list_actions_result = [];

				this.$refs.edit_tabulator.set_data([this.column_import]);
				this.$refs.edit_tabulator.set_column_import_opt(
					this.column_import_opt
				);

				this.project_obj = this.list_projects.find(
					(item) => item.uid === this.project
				);
				this.scenario =
					this.list_scenarios[this.project_obj.details.scenario];
			},
			start: async function (_tags, _project, _type, main = true) {
				var self = this;

				this.main = main;
				this.actions_result = false;
				if (this.tabulator_data && main == true) {
					var name_file_tabulator = this.name_file_tabulator;
					var tabulator_data_csv =
						await this.$refs.edit_tabulator.get_data_blob();
				} else if (main == false) {
					var name_file_tabulator = this.name_file_tabulator;
					var tabulator_data_csv =
						await this.$refs.myTreatment.getCsv();
				}

				//   console.log("Tabulator_data_csv: ", tabulator_data_csv);

				this.start_project = this.project;
				if (_project) this.start_project = _project;
				this.start_tags = [];
				if (_tags) this.start_tags = _tags;

				var type = "import";
				if (_type) type = _type;

				this.launch = true;

				treatments
					.create(
						this.start_project,
						this.format,
						tabulator_data_csv,
						name_file_tabulator,
						this.start_tags,
						type
					)
					.then((res) => {
						//this.$router.push({ name: 'treatment', params: { id: res.treatment.uid } })
						this.launch = false;
						this.first = true;
						this.$refs.myTreatment.start(
							res.treatment.uid,
							false,
							1000
						);
					})
					.catch((err) => {
						console.log("error : " + err);
						this.$notify({
							group: "info",
							title: err.response.data.msg,
							type: "error",
						});
					});
			},
			progress(totaluploadprogress, totalBytes, totalBytesSent) {
				this.counter = totaluploadprogress;
			},
			setInputMenu(input_menu) {
				this.input_menu = input_menu;
			},
		},
		mounted: async function () {
			if (store.state.user.rules && !store.state.user.rules.projects) {
				this.$router.push({ name: "profile" });
			}

			var self = this;
			this.resolve = null;

			window.setInputMenu = this.setInputMenu;

			await this.getProjects();
			await this.getScenarios();
			for (var i = 0; i < this.list_projects.length; i++) {
				if (
					this.list_projects[i].details &&
					this.list_projects[i].details.test == true
				) {
					this.project = this.list_projects[i]["uid"];
					this.changeProject();
				}

				if (
					this.list_projects[i].details &&
					this.list_projects[i].details.hasOwnProperty(
						"inDropdownTraitements"
					) &&
					this.list_projects[i].details.inDropdownTraitements ===
						false
				)
					continue;

				this.list_formats[this.list_projects[i]["uid"]] = null;
				this.list_documentation[this.list_projects[i]["uid"]] =
					this.list_projects[i]["documentation"];
				this.list_details[this.list_projects[i]["uid"]] =
					this.list_projects[i]["details"];
				this.projects_options.push({
					value: this.list_projects[i]["uid"],
					text: this.list_projects[i]["libelle"],
				});
				if (this.list_projects[i]["formats"]) {
					this.list_formats[this.list_projects[i]["uid"]] = [
						{ value: null, text: "Sélectionner un format" },
					];
					for (
						var j = 0;
						j < this.list_projects[i]["formats"].length;
						j++
					) {
						if (
							this.list_projects[i]["formats"][j]["usage"] ==
							"Import"
						) {
							this.list_formats[
								this.list_projects[i]["uid"]
							].push({
								value: this.list_projects[i]["formats"][j][
									"uid"
								],
								text: this.list_projects[i]["formats"][j][
									"libelle"
								],
							});
						}
					}
					if (
						this.list_formats[this.list_projects[i]["uid"]]
							.length <= 1
					) {
						this.list_formats[this.list_projects[i]["uid"]] = null;
					}
				}
			}
		},
	};
</script>

<style>
	.center_spinner {
		width: 0%;
		margin: 0 auto;
		margin-top: 30px;
	}

	.tabulator-menu {
		position: absolute;
		background-color: white;
		border: 1px solid;
		cursor: pointer;
		padding: 5px;
	}
</style>

